// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rx-shell {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  min-height: 100dvh;
  max-width: 390px;
  margin: 0 auto;
  background: var(--paper);
  color: var(--ink);
}

.rx-main {
  position: relative;
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
}

.rx-nav {
  position: sticky;
  bottom: 0;
  z-index: 2;
  flex: 0 0 auto;
  display: flex;
  align-items: stretch;
  justify-content: space-around;
  border-top: 1px solid var(--rule);
  background: var(--paper);
  padding: 8px 0 calc(8px + env(safe-area-inset-bottom, 0px));
}

.rx-nav__item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  flex: 1;
  min-width: 0;
  padding: 6px 4px;
  font-family: var(--font-mono);
  font-size: 9px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--ink-3);
}

.rx-nav__item svg {
  flex: 0 0 auto;
}

.rx-nav__item--current {
  color: var(--ink);
}

a.rx-nav__item {
  text-decoration: none;
}

.rx-nav__brand {
  display: none;
}

.rx-nav__item:focus-visible {
  outline: 2px solid var(--signal);
  outline-offset: 3px;
}

/* Shared shell for Solicitudes and Perfil: a rail on the left and one page
   column on the right, as wide as --receptor-page-max, for every view. */
@media (min-width: 1024px) {
  .receptor-shell.rx-shell,
  .receptor-shell.pf-shell {
    max-width: none;
    display: grid;
    grid-template-columns: 176px minmax(0, 1fr);
    align-items: start;
  }

  .receptor-main.rx-main,
  .receptor-main.pf-main {
    grid-column: 2;
    grid-row: 1;
    min-width: 0;
    width: 100%;
    max-width: none;
    margin: 0 auto;
    --receptor-main-padding: 32px;
    --receptor-page-max: 1200px;
    padding: var(--receptor-main-padding);
    overflow: visible;
  }

  .receptor-shell .rx-nav {
    grid-column: 1;
    grid-row: 1;
    position: sticky;
    top: 0;
    bottom: auto;
    height: 100vh;
    height: 100dvh;
    overflow-y: auto;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    padding: 32px 16px;
    gap: 8px;
    border-top: 0;
    border-right: 1px solid var(--rule);
    background: var(--surface);
  }

  .rx-nav__brand {
    display: block;
    margin-bottom: 32px;
    font-family: 'Newsreader', Georgia, serif;
    font-weight: 300;
    font-size: 20px;
    letter-spacing: 0.04em;
    color: var(--ink);
  }

  .rx-nav__brand strong {
    font-weight: 600;
  }

  .receptor-shell .rx-nav__item {
    flex: 0 0 auto;
    flex-direction: row;
    justify-content: flex-start;
    padding: 12px 8px;
    gap: 8px;
    min-height: 44px;
    font-size: var(--fs-eyebrow);
    letter-spacing: 0.06em;
  }

  .receptor-shell .rx-nav__item--current {
    color: var(--signal-deep);
    background: var(--signal-soft);
  }

  .rx-nav__count {
    margin-left: auto;
    min-width: 22px;
    padding: 1px 6px;
    border: 1px solid var(--rule);
    font-family: var(--font-mono);
    font-size: var(--fs-pico);
    letter-spacing: 0;
    text-align: center;
    color: var(--ink-2);
  }

  .rx-nav__foot {
    margin-top: auto;
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding-top: 16px;
    border-top: 1px solid var(--rule-soft);
  }

  .rx-nav__user {
    margin: 0;
    padding: 0 8px;
    font-size: var(--fs-ui);
    line-height: var(--leading-body);
    color: var(--ink);
    overflow-wrap: anywhere;
  }

  .rx-nav__logout {
    min-height: 44px;
    padding: 12px 8px;
    border: 0;
    background: transparent;
    text-align: left;
    cursor: pointer;
    font-family: var(--font-mono);
    font-size: var(--fs-eyebrow);
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: var(--ink-3);
  }

  .rx-nav__logout:hover {
    color: var(--ink);
  }

  .rx-nav__logout:focus-visible {
    outline: 2px solid var(--signal);
    outline-offset: 3px;
  }
}

/* Los encabezados reciben foco por código para que el lector de pantalla
   anuncie la vista nueva; no son controles, así que no muestran el anillo. */
.receptor-main [tabindex='-1']:focus {
  outline: none;
}
`, "",{"version":3,"sources":["webpack://./src/pages/solicitudes/ReceptorLayout.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB,6BAA6B;EAC7B,iCAAiC;EACjC,wBAAwB;EACxB,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;yEACyE;AACzE;EACE;;IAEE,eAAe;IACf,aAAa;IACb,2CAA2C;IAC3C,kBAAkB;EACpB;;EAEA;;IAEE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,WAAW;IACX,eAAe;IACf,cAAc;IACd,6BAA6B;IAC7B,2BAA2B;IAC3B,qCAAqC;IACrC,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,MAAM;IACN,YAAY;IACZ,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,2BAA2B;IAC3B,oBAAoB;IACpB,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb,mCAAmC;IACnC,0BAA0B;EAC5B;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,2BAA2B;IAC3B,iBAAiB;IACjB,QAAQ;IACR,gBAAgB;IAChB,4BAA4B;IAC5B,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;IACzB,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,6BAA6B;IAC7B,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,iBAAiB;IACjB,sCAAsC;EACxC;;EAEA;IACE,SAAS;IACT,cAAc;IACd,uBAAuB;IACvB,gCAAgC;IAChC,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;IACT,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,4BAA4B;IAC5B,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gCAAgC;IAChC,mBAAmB;EACrB;AACF;;AAEA;6EAC6E;AAC7E;EACE,aAAa;AACf","sourcesContent":[".rx-shell {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  min-height: 100dvh;\n  max-width: 390px;\n  margin: 0 auto;\n  background: var(--paper);\n  color: var(--ink);\n}\n\n.rx-main {\n  position: relative;\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: auto;\n}\n\n.rx-nav {\n  position: sticky;\n  bottom: 0;\n  z-index: 2;\n  flex: 0 0 auto;\n  display: flex;\n  align-items: stretch;\n  justify-content: space-around;\n  border-top: 1px solid var(--rule);\n  background: var(--paper);\n  padding: 8px 0 calc(8px + env(safe-area-inset-bottom, 0px));\n}\n\n.rx-nav__item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  flex: 1;\n  min-width: 0;\n  padding: 6px 4px;\n  font-family: var(--font-mono);\n  font-size: 9px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--ink-3);\n}\n\n.rx-nav__item svg {\n  flex: 0 0 auto;\n}\n\n.rx-nav__item--current {\n  color: var(--ink);\n}\n\na.rx-nav__item {\n  text-decoration: none;\n}\n\n.rx-nav__brand {\n  display: none;\n}\n\n.rx-nav__item:focus-visible {\n  outline: 2px solid var(--signal);\n  outline-offset: 3px;\n}\n\n/* Shared shell for Solicitudes and Perfil: a rail on the left and one page\n   column on the right, as wide as --receptor-page-max, for every view. */\n@media (min-width: 1024px) {\n  .receptor-shell.rx-shell,\n  .receptor-shell.pf-shell {\n    max-width: none;\n    display: grid;\n    grid-template-columns: 176px minmax(0, 1fr);\n    align-items: start;\n  }\n\n  .receptor-main.rx-main,\n  .receptor-main.pf-main {\n    grid-column: 2;\n    grid-row: 1;\n    min-width: 0;\n    width: 100%;\n    max-width: none;\n    margin: 0 auto;\n    --receptor-main-padding: 32px;\n    --receptor-page-max: 1200px;\n    padding: var(--receptor-main-padding);\n    overflow: visible;\n  }\n\n  .receptor-shell .rx-nav {\n    grid-column: 1;\n    grid-row: 1;\n    position: sticky;\n    top: 0;\n    bottom: auto;\n    height: 100vh;\n    height: 100dvh;\n    overflow-y: auto;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: stretch;\n    padding: 32px 16px;\n    gap: 8px;\n    border-top: 0;\n    border-right: 1px solid var(--rule);\n    background: var(--surface);\n  }\n\n  .rx-nav__brand {\n    display: block;\n    margin-bottom: 32px;\n    font-family: 'Newsreader', Georgia, serif;\n    font-weight: 300;\n    font-size: 20px;\n    letter-spacing: 0.04em;\n    color: var(--ink);\n  }\n\n  .rx-nav__brand strong {\n    font-weight: 600;\n  }\n\n  .receptor-shell .rx-nav__item {\n    flex: 0 0 auto;\n    flex-direction: row;\n    justify-content: flex-start;\n    padding: 12px 8px;\n    gap: 8px;\n    min-height: 44px;\n    font-size: var(--fs-eyebrow);\n    letter-spacing: 0.06em;\n  }\n\n  .receptor-shell .rx-nav__item--current {\n    color: var(--signal-deep);\n    background: var(--signal-soft);\n  }\n\n  .rx-nav__count {\n    margin-left: auto;\n    min-width: 22px;\n    padding: 1px 6px;\n    border: 1px solid var(--rule);\n    font-family: var(--font-mono);\n    font-size: var(--fs-pico);\n    letter-spacing: 0;\n    text-align: center;\n    color: var(--ink-2);\n  }\n\n  .rx-nav__foot {\n    margin-top: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    padding-top: 16px;\n    border-top: 1px solid var(--rule-soft);\n  }\n\n  .rx-nav__user {\n    margin: 0;\n    padding: 0 8px;\n    font-size: var(--fs-ui);\n    line-height: var(--leading-body);\n    color: var(--ink);\n    overflow-wrap: anywhere;\n  }\n\n  .rx-nav__logout {\n    min-height: 44px;\n    padding: 12px 8px;\n    border: 0;\n    background: transparent;\n    text-align: left;\n    cursor: pointer;\n    font-family: var(--font-mono);\n    font-size: var(--fs-eyebrow);\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: var(--ink-3);\n  }\n\n  .rx-nav__logout:hover {\n    color: var(--ink);\n  }\n\n  .rx-nav__logout:focus-visible {\n    outline: 2px solid var(--signal);\n    outline-offset: 3px;\n  }\n}\n\n/* Los encabezados reciben foco por código para que el lector de pantalla\n   anuncie la vista nueva; no son controles, así que no muestran el anillo. */\n.receptor-main [tabindex='-1']:focus {\n  outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
